import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const BreadCrumb = ({ currentPage }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <nav style={{ 
      maxWidth: "100%",
      height: "auto", 
      backgroundColor: "transparent",
      padding: "0px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center"
    }}>
      <ol style={{ paddingLeft: 0 }} className="inline-flex items-center">
        <li className="inline-flex items-center">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-red-600">
            <svg className="w-3 h-3 mr-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
              <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
            </svg>
            Home
          </Link>
        </li>
        {pathnames.map((name, index) => {
          let routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          if (name === "ads") {
            routeTo = "/advertising";
          }
          const isLast = index === pathnames.length - 1;
          
          return (
            <li key={name}>
              <div className="flex items-center">
                <svg className="w-3 h-3 mx-1 text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
                </svg>
                {isLast ? (
                  <span className="ml-1 text-sm font-medium text-gray-500">
                    {currentPage}
                  </span>
                ) : (
                  <Link 
                    to={routeTo}
                    className="ml-1 text-sm font-medium text-gray-700 hover:text-red-600"
                  >
                    {name.charAt(0).toUpperCase() + name.slice(1)}
                  </Link>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadCrumb;
